import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import React, { Fragment, useEffect, useState } from "react";
import { errorMsg, success } from "../../../utils/notifications";
import { addOwner, getOwnerById, updateOwner } from "../../../api/owners.api";
import { LuImagePlus } from "react-icons/lu";
import { baseURL } from "../../../api/api";
import { MdRemoveRedEye } from "react-icons/md";
import { FaEyeSlash } from "react-icons/fa";

const initialData = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  profileImage: "",
  ownerName: "",
  ownerEmail: "",
  ownerPhone: "",
  ownerAddress: "",
  companyDescription: "",
  accountHolder: "",
  accountNumber: "",
  bankName: "",
};
const AddOwner = ({ open, setOpen, fetchAllOwners, editOwnerId }) => {
  const [addOwnerData, setAddOwnerData] = useState(initialData);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    setAddOwnerData(editOwnerId || initialData);
  }, [editOwnerId]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    console.log("image is", file);
  };

  const handleTogglePassword = (fieldName) => {
    if (fieldName === "password") {
      setShowPassword(!showPassword);
    }
  };
  useEffect(() => {
    if (editOwnerId) {
      getOwnerById(editOwnerId)
        .then((res) => {
          console.log("get by id", res?.data);
          setAddOwnerData({
            ownerName: res?.data?.owner?.name,
            ownerEmail: res?.data?.owner?.email,
            ownerAddress: res?.data?.owner?.address,
            ownerPhone: res?.data?.owner?.phone,
            // bank info
            accountHolder: res?.data?.owner?.bankInfo?.accountHolder,
            accountNumber: res?.data?.owner?.bankInfo?.accountNumber,
            bankName: res?.data?.owner?.bankInfo?.bankName,
            // user infor
            profileImage: res?.data?.owner?.userId?.profileImage,
            firstName: res?.data?.owner?.userId?.firstName,
            lastName: res?.data?.owner?.userId?.lastName,
            phone: res?.data?.owner?.userId?.phone,
            email: res?.data?.owner?.userId?.email,
            password: res?.data?.owner?.userId?.password,
          });
        })
        .catch((err) => {
          errorMsg("get By Id", err?.response?.data?.message);
          console.log("Error is", err);
        });
    } else {
      setAddOwnerData(initialData);
      setSelectedFile(null);
    }
  }, [editOwnerId]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setAddOwnerData({
      ...addOwnerData,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    console.log("this is", addOwnerData);

    const formData = new FormData();
    formData.append("profileImage", selectedFile);
    formData.append("firstName", addOwnerData.firstName);
    formData.append("lastName", addOwnerData.lastName);
    formData.append("phone", addOwnerData.phone);
    formData.append("email", addOwnerData.email);
    formData.append("password", addOwnerData.password);
    formData.append("ownerName", addOwnerData.ownerName);
    formData.append("ownerEmail", addOwnerData.ownerEmail);
    formData.append("ownerPhone", addOwnerData.ownerPhone);
    formData.append("ownerAddress", addOwnerData.ownerAddress);
    formData.append("companyDescription", addOwnerData.companyDescription);
    formData.append("accountHolder", addOwnerData.accountHolder);
    formData.append("accountNumber", addOwnerData.accountNumber);
    formData.append("bankName", addOwnerData.bankName);

    console.log(formData);
    for (var pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    try {
      if (editOwnerId) {
        await updateOwner(editOwnerId, formData).then((res) => {
          console.log(res?.data);
          success("Successful", "owner Updated Successfully");
          fetchAllOwners();
          setOpen(false);
        });
      } else {
        await addOwner(formData).then((res) => {
          console.log(res?.data);
          setAddOwnerData(initialData);
          setSelectedFile(null);
          setOpen(false);
          success("Successful", "Owner Added Successfully");
          fetchAllOwners();
        });
      }
    } catch (err) {
      errorMsg("Oops", err?.response?.data?.message);
      console.log("Error is", err);
    } finally {
      setIsSubmitting(false); // Re-enable the button when done
    }
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="z-50" onClose={setOpen}>
        <Transition.Child
          enter="ease-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-300"
          leaveFrom="opacity-100 transform scale-100"
          leaveTo="opacity-0 transform scale-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-500"
              enterFrom="opacity-0 transform scale-0"
              enterTo="opacity-100 transform scale-100"
              leave="ease-in duration-300"
              leaveFrom="opacity-100 transform scale-100"
              leaveTo="opacity-0 transform scale-0"
            >
              <Dialog.Panel className="mt-12 lg:ml-60 md:ml-60 ml-0 z-50 lg:w-1/2 md:w-1/2 w-4/5 fixed mx-auto rounded-lg bg-white pt-5 pb-4 text-left shadow-xl transition-all h-auto">
                <div className="absolute top-0 right-0 pt-4 pr-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="">
                  <div className=" sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="px-3 pb-5 text-xl font-medium border-b-2 border-gray-200 leading-6 text-gray-700"
                    >
                      {editOwnerId ? "Update Owner" : "Add Owner"}
                    </Dialog.Title>
                    <div className="">
                      <form onSubmit={handleSubmit} method="POST">
                        <div className="h-[30rem] overflow-y-scroll">
                          <div className="px-7 py-4">
                            <div className="flex items-center justify-between">
                              <div>
                                <h2 className="text-xl font-semibold text-gray-400 ">
                                  Owner Information
                                </h2>
                              </div>
                            </div>
                            <div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="profileImage"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Profile Image
                                  </label>
                                </div>
                                <div className="text-left lg:col-span-7 md:col-span-7 sm:col-span-12">
                                  <div className="w-1/3 mt-2 ">
                                    <label
                                      htmlFor="profileImage"
                                      className="mx-auto bg-gray-100 rounded-full h-28 w-28 inset-0 flex items-center justify-center cursor-pointer"
                                    >
                                      {selectedFile ||
                                      (editOwnerId &&
                                        addOwnerData?.profileImage) ? (
                                        <img
                                          src={
                                            selectedFile
                                              ? URL.createObjectURL(
                                                  selectedFile
                                                )
                                              : `${baseURL}/s3/images/${addOwnerData?.profileImage}`
                                          }
                                          alt="Selected"
                                          className="rounded-full h-full w-full object-cover"
                                        />
                                      ) : (
                                        <LuImagePlus className="text-gray-400 h-14 w-14 p-2" />
                                      )}
                                    </label>
                                    <input
                                      type="file"
                                      name="profileImage"
                                      id="profileImage"
                                      className="hidden"
                                      onChange={handleFileChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="ownerName"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Name{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="ownerName"
                                      placeholder="Enter Owner name"
                                      value={addOwnerData?.ownerName}
                                      onChange={handleChange}
                                      id="ownerName"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="ownerEmail"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Email{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="email"
                                      name="ownerEmail"
                                      placeholder="Enter Owner Email"
                                      value={addOwnerData?.ownerEmail}
                                      onChange={handleChange}
                                      id="ownerEmail"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="ownerAddress"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Address{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="ownerAddress"
                                      placeholder="Enter Owner Address"
                                      value={addOwnerData?.ownerAddress}
                                      onChange={handleChange}
                                      id="ownerAddress"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="ownerPhone"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Phone{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="ownerPhone"
                                      placeholder="Enter Owner Phone"
                                      value={addOwnerData?.ownerPhone}
                                      onChange={handleChange}
                                      id="ownerPhone"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <h1 className="text-xl text-gray-400 font-semibold">
                                Bank Info
                              </h1>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="accountHolder"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Account Holder{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="accountHolder"
                                      placeholder="Enter Account Holder"
                                      value={addOwnerData?.accountHolder}
                                      onChange={handleChange}
                                      id="accountHolder"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="accountNumber"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Account Number{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="accountNumber"
                                      placeholder="Enter Account Number"
                                      value={addOwnerData?.accountNumber}
                                      onChange={handleChange}
                                      id="accountNumber"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="bankName"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Bank Name{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="bankName"
                                      placeholder="Enter bank Name"
                                      value={addOwnerData?.bankName}
                                      onChange={handleChange}
                                      id="bankName"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <h1 className="text-xl text-gray-400 font-semibold">
                                User Information
                              </h1>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="firstName"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    First Name{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="firstName"
                                      placeholder="Enter First Name"
                                      value={addOwnerData?.firstName}
                                      onChange={handleChange}
                                      id="firstName"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="lastName"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Last Name{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="text"
                                      name="lastName"
                                      placeholder="Enter Last Name"
                                      value={addOwnerData?.lastName}
                                      onChange={handleChange}
                                      id="lastName"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                  <label
                                    htmlFor="email"
                                    className="block text-base font-semibold leading-6 text-gray-800"
                                  >
                                    Email{" "}
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                </div>
                                <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                  <div className="mt-2">
                                    <input
                                      type="email"
                                      name="email"
                                      placeholder="Enter email"
                                      value={addOwnerData?.email}
                                      onChange={handleChange}
                                      id="email"
                                      className="text-sm font-medium bg-white bg-opacity-80 px-3 block w-full rounded-md outline-0 py-2 text-gray-600 placeholder:text-gray-300 border-2 border-gray-200 border-opacity-70 focus:border-2 focus:border-yellowColor sm:leading-6 focus:ring-transparent"
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              {!editOwnerId && (
                                <div className="py-0.5 md:py-1.5 lg:py-1.5 items-center grid grid-cols-1 sm:grid-cols-12 lg:grid-cols-12 md:grid-cols-12">
                                  <div className="lg:col-span-5 md:col-span-5 sm:col-span-12 ">
                                    <label
                                      htmlFor="password"
                                      className="block text-base font-semibold leading-6 text-gray-800"
                                    >
                                      Password{" "}
                                      <span className="text-red-500 ">*</span>
                                    </label>
                                  </div>
                                  <div className="lg:col-span-7 md:col-span-7 sm:col-span-12 ">
                                    <div className="mt-2 relative">
                                      <input
                                        type={
                                          showPassword ? "text" : "password"
                                        }
                                        name="password"
                                        placeholder="Password"
                                        value={addOwnerData.password}
                                        onChange={handleChange}
                                        id="password"
                                        className="text-base font-medium bg-neutral-100 bg-opacity-80 px-3 pr-10 block w-full rounded-md border-0 outline-0 py-2.5 text-gray-600 placeholder:text-gray-400 border-2 border-transparent focus:border-2 focus:border-yellowColor sm:leading-6"
                                        required
                                      />
                                      {/* Eye icon */}
                                      <button
                                        className="absolute inset-y-0 right-0 flex items-center pr-3"
                                        onClick={() =>
                                          handleTogglePassword("password")
                                        }
                                        type="button"
                                      >
                                        {showPassword ? (
                                          <FaEyeSlash className="cursor-pointer text-gray-400 text-2xl" />
                                        ) : (
                                          <MdRemoveRedEye className="cursor-pointer text-gray-400 text-2xl" />
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="border-t-2 border-gray-200 px-7 pt-3 flex items-center justify-end">
                          <button
                            type="submit"
                            disabled={isSubmitting}
                            className={`flex justify-center rounded-md bg-yellowColor  py-2.5 px-10 text-base font-semibold leading-6 text-dark shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor ${
                              isSubmitting
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            {isSubmitting
                              ? "Processing..."
                              : editOwnerId
                              ? "Update"
                              : "Submit"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default AddOwner;
